
import ImageShow from '../components/images/ImageShow.vue';
import Vue from 'vue';

Vue.component('image-show', ImageShow);

export default Vue.extend({});
